// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/tropical-cyclone.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/tropical-cyclone/tropical-cyclone-decay.js';
import g1 from '../lessons/meteorology/tropical-cyclone/tropical-cyclone-formation.js';
import g2 from '../lessons/meteorology/tropical-cyclone/tropical-cyclone-structure.js';
import g3 from '../lessons/meteorology/tropical-cyclone/tropical-cyclone-track.js';
import g4 from '../lessons/meteorology/tropical-cyclone/tropical-cyclone.js';

mount([g0, g1, g2, g3, g4]);
